import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import { api } from '../lib/api-client';
import { syncFireAndForget } from '../lib/sync';

export interface ChatMsg {
  id: string;
  from: 'coach' | 'user';
  text: string;
}

export interface ChatState {
  messages: ChatMsg[];

  /** Replace the stored conversation with the completed turns. */
  setMessages: (messages: ChatMsg[]) => void;
  /** Start-over button: wipe the conversation so a fresh opener can stream. */
  clear: () => void;
  /** Overwrite from the server bundle on boot (reserved for future sync). */
  hydrate: (messages: ChatMsg[]) => void;
  /** reset-all registry — wipe on signout / Profile reset. */
  reset: () => void;
}

export const useChatStore = create<ChatState>()(
  persist(
    (set) => ({
      messages: [],
      setMessages: (messages) => {
        set({ messages });
        // 401 is swallowed for anonymous users; for signed-in users this syncs
        // the conversation so it follows them across devices.
        syncFireAndForget(() => api.chat.save({ messages }));
      },
      clear: () => {
        set({ messages: [] });
        syncFireAndForget(() => api.chat.clear());
      },
      hydrate: (messages) => set({ messages }),
      reset: () => set({ messages: [] }),
    }),
    {
      name: 'llura.chat',
      storage: createJSONStorage(() => localStorage),
      version: 1,
    },
  ),
);
